import {t} from 'app/translations';
import {EskotValidator} from 'utils/eskot-validator';
import {Errors} from 'utils/validator';

import {SubjectFacilityFormValues} from '../../types/subject-facility-form-values';

const te = t('userDetail');

/** Validation inputs used to build the organizations tab validator. */
interface ValidatorProps {
    /** Whether center selection must be present. */
    centersRequired: boolean;
    /** Whether farm selection must be present. */
    farmsRequired: boolean;
    /** Whether the current row is being edited instead of created. */
    isEdit: boolean;
}

/**
 * Builds the organization-form validator for create and edit flows.
 *
 * @param props `centersRequired`, `farmsRequired`, and `isEdit` control which organization fields are required.
 * @returns A validator that enforces organization approval, centers, farms, and roles.
 *
 * @example
 * const validate = createValidate({centersRequired: true, farmsRequired: false, isEdit: false});
 */
export const createValidate = ({centersRequired, farmsRequired, isEdit}: ValidatorProps) =>
    (values: SubjectFacilityFormValues): Errors<SubjectFacilityFormValues> => {
        const validator = new EskotValidator(values);
        const approveIsInvalid = (
            values.approvedFrom !== null
            && values.approvedTo !== null
            && values.approvedFrom > values.approvedTo
        );

        validator.customRule(
            'approvedTo',
            approveIsInvalid,
            te('dateFromToIsInvalid'),
        );

        if (!isEdit) validator.nonEmpty('approvedFrom', te('approvedFrom'));
        validator.nonEmpty('subjectId', te('organization'));
        if (centersRequired) validator.nonEmpty('centerIds', te('centers'));
        if (farmsRequired) validator.nonEmpty('farmIds', te('farms'));

        validator.nonEmpty('roleIds', te('roles'));

        return validator.generateErrorsObject();
    };
